<template>
    <div class="appointment-list">
        <listSkeleton v-if="isLoading" />
        <div class="appointment-list-content" v-else>
            <van-list v-if="channelList" v-model="loading" :finished="finished" finished-text="已到底部" :immediate-check="false" @load="onLoad">
                <div
                    class="appointment-list-content-item"
                    v-for="item in channelList"
                    :key="item.id"
                    @click="goDetail(item)"
                >
                    <div class="appointment-list-content-item-type">
                        <img v-if="item.live_status == 0" src="/static/img/live/icon_list_tag_live_count_down.svg" alt="" />
                        <img v-else-if="item.live_status == 1" src="/static/img/live/icon_list_tag_live_process.svg" alt="" />
                        <img v-else-if="item.live_status == 2" src="/static/img/live/icon_list_tag_live_history.svg" alt="" />
                        <van-count-down :time="item.limit_time" class="live-detail-count-down" v-if="item.limit_time > 0">
                            <template #default="timeData">
                                <span>距离直播</span>
                                <span class="times">{{ timeData.days }}</span>
                                <span class="time_unit">天</span>
                                <span class="times">{{ timeData.hours }}</span>
                                <span class="time_unit">时</span>
                                <span class="times">{{ timeData.minutes }}</span>
                                <span class="time_unit">分</span>
                                <span class="times">{{ timeData.seconds }}</span>
                                <span class="time_unit">秒</span>
                            </template>
                        </van-count-down>
                    </div>
                    <div class="appointment-list-content-item-subject">
                        <img :src="item.cover_img" alt="" />
                    </div>
                    <div
                        :class="[
                            item.title.length > 19 ? 'appointment-list-content-item-template-title-log' : 'appointment-list-content-item-template'
                        ]"
                    >
                        <div class="appointment-list-content-item-template-title">{{ item.title }}</div>
                        <div class="appointment-list-content-item-template-date">{{ item.start_at }}</div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import listSkeleton from '@/skeleton/listSkeleton'
export default {
    components: {
        listSkeleton
    },
    data() {
        return {
            loading: true,
            finished: false,
            isLoading: true,
            channelList: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0
        }
    },
    created() {
        this.fetch('channelList')
    },
    methods: {
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelList')
        },
        goDetail(item) {
            Interface.goLiveDetail(this,{
                type :1 ,
                ...item
            })
        },
        fetch(scene) {
            if (scene === 'channelList') {
                Interface.getData('get', '/live/api/appointment', this.page).then(res => {
                    if (res.data.list == null) {
                        this.finished = true
                        return
                    }
                    this.channelList = [...this.channelList, ...res.data.list]
                    this.total = res.data.total
                    this.loading = false
                    this.isLoading = false

                    if (this.channelList.length >= this.total) {
                        this.finished = true
                    }
                })
            } else if (scene === 'info') {
                Interface.getData('get', '/course/api/article/detail/' + this.$route.params.id).then(res => {
                    this.pageInfo = res
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.appointment-list {
    &-content {
        &-item {
            position: relative;
            width: 355px;
            height: 200px;
            border-radius: 8px;
            margin: 17px 10px 17px 10px;

            &-type {
                position: absolute;
                left: 1px;
                top: 19px;
                height: 18px;
                border-radius: 6px 2px 6px 2px;
                display: flex;
                align-items: center;
                position: relative;

                .live-detail-count-down {
                    display: flex;
                    background: rgba(18, 20, 30, 0.6);
                    font-size: 10px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    height: 18px;
                    padding-top: 2px;
                    box-sizing: border-box;
                    padding-right: 5px;
                    border-radius: 0px 5px 5px 0px;

                    span {
                        &:nth-child(1) {
                            margin-left: 5px;
                        }
                        padding: 0px 2px;
                    }
                }

                span {
                    padding: 0px 5px;
                    line-height: 18px;
                    font-size: 10px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 14px;
                }
            }

            &-subject {
                height: 200px;
                width: 355px;
                border-radius: 8px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                }
            }

            &-template {
                position: absolute;
                height: 50px;
                top: 95px;
                left: 0px;
                width: 339px;
                width: 355px;
                height: 120px;
                background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.5) 100%);
                border-radius: 0px 0px 6px 6px;

                &-title {
                    font-size: 17px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 24px;
                    margin-bottom: 10px;
                    padding-top: 55px;
                    padding-left: 14px;
                }

                &-date {
                    font-size: 13px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    padding-left: 14px;
                    line-height: 18px;
                }
            }

            &-template-title-log {
                position: absolute;
                top: 75px;
                left: 0px;
                width: 355px;
                height: 140px;
                background: linear-gradient(180deg, rgba(34, 34, 34, 0) 0%, rgba(0, 0, 0, 0.2) 40%, rgba(0, 0, 0, 0.5) 100%);
                border-radius: 0px 0px 6px 6px;

                &-title {
                    font-size: 17px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;

                    color: #ffffff;
                    line-height: 24px;
                    margin-bottom: 10px;
                }

                &-date {
                    font-size: 13px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;

                    line-height: 18px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/live/appointment-list/index.vue